import React, { Component } from 'react';

export default class view extends Component {
	render() {

		var PAList = []
		for (var pa of this.props.data.PAList) {
			console.log(pa)
			var completed = (pa.Rec_Complete != 'Y' ? ("This prior authorization has not yet been completed by a pharmacy or DME provider.") : ("This prior authorization was completed on " + new Date(pa.Pharmacy_Date).toLocaleDateString() + " under Billing Code " + pa.NDC_Code.slice(4, 11) + "."))
			var cancelled = (pa.Admin_Canceled == 'Y' ? ("THIS PA HAS BEEN CANCELLED.") : (""))
			PAList.push(
				<div>
					<p>PA Number {pa.PA_Number} for {pa.Refills_Requested} refills for {pa.Cals_Req}  calories per day and  was requested by you on  {new Date(pa.Request_Date).toLocaleDateString()}.
					</p>
					<p>{completed}</p>
					<p>{cancelled}</p>
					<p>The earliest that this formula can be reauthorized is: {new Date((new Date(pa.Expiration_Date) - (86400000 * 10))).toLocaleDateString()}.</p>
				</div>
			)
		}

		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>You have requested the following authorizations for this member:</p>
				{PAList}
				<div className="button" onClick={() => this.props.navigate('A2')}>Perform an inquiry on a different member</div>
			</div>
		);
	}
}